import React from 'react';
import { GivelifyPaper } from '@givelify/ui';
import { styled } from '@mui/material';

const StyledPaper = styled(GivelifyPaper)(({ theme }) => ({
    padding: '24px 32px',
    position: 'relative',
    height: 336,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'initial',
    [theme.breakpoints.down('tablet')]: {
        height: 316,
    },
    [theme.breakpoints.down('mobile')]: {
        padding: '16px',
        height: 304,
    },
}));

export const WidgetPaper: React.FCC = ({ children }) => {
    return <StyledPaper translate={undefined}>{children}</StyledPaper>;
};
